import { Injectable } from "@angular/core";
import { Subject, Observable } from "rxjs";

@Injectable()
export class InfoCardSearchService
{
    private readonly searchAction$ = new Subject<{ [name: string]: any }>();

    get onSearchAction(): Observable<{ [name: string]: any }>
    {
        return this.searchAction$.asObservable();
    }

    fireSearchActionListeners(value: { [name: string]: any }): void
    {
        this.searchAction$.next(value);
    }
}
